import React, { useEffect, useState, useRef } from 'react';
import { useLoadingContext } from "react-router-loading";
import * as api from './lib/api';
import Select from 'react-select';
const JitsiMeetJS = window.JitsiMeetJS;

function SceneSettings() {
    const loadingContext = useLoadingContext();

    let [isLoading, setLoading] = useState(true);

    let [tableOptions, setTableOptions] = useState([]);
    let [tableSelected, setTableSelected] = useState({});

    let [inputVideoOptions, setInputVideoOptions] = useState([]);
    let [inputTracks, setInputTracks] = useState({});
    let [inputTopSelected, setInputTopSelected] = useState('');
    let [inputBillBoardSelected, setInputBillBoardSelected] = useState('');

    let [state, setState] = useState({});

    // refs
    const refCameraTopViewVideo = useRef();
    const refCameraBillboardVideo = useRef();

    function isTableChanges() {
        let saveSelectedValue = api.getSavedTableId();
        return tableSelected?.value === saveSelectedValue;
    }

    async function discardRoomChanges() {
        let saveSelectedValue = api.getSavedTableId();
        let currentSelected = null;

        let tables = tableOptions;
        for (let i = 0; i < tables.length; i++) {
            const item = tables[i];
            if (saveSelectedValue === item.value) {
                currentSelected = item;
            }
        }

        if (!currentSelected) saveSelectedValue = '';

        api.setApplicationRoom(saveSelectedValue);

        setTableSelected(currentSelected);
        // console.log(`discardRoomChanges`, saveSelectedValue, currentSelected, tables);
    }

    async function saveRoom() {
        if (!tableSelected) return;
        let value = tableSelected.value;

        api.setApplicationRoom(value);

        setState({
            ...state
        });
        // console.log(`saveRoom`, selected);
    }

    async function loadTables() {
        let tables = await api.getTables();
        let options = [];

        let saveSelectedValue = api.getSavedTableId();
        let currentSelected = null;

        for (let i = 0; i < tables.length; i++) {
            const item = tables[i];

            let op = {
                value: item.id,
                label: item.name || 'Untitled',
                item: item
            };
            options.push(op);
            if (saveSelectedValue === op.value) {
                currentSelected = op;
            }
        }

        setTableOptions(options);
        setTableSelected(currentSelected);
    }

    async function loadInputs() {
        discardInputChanges();
    }

    function saveInputs() {
        api.setApplicationInputs(inputTopSelected, inputBillBoardSelected);
        console.log(`saveInputs`, inputTopSelected, inputBillBoardSelected);
        setState({
            ...state
        });
    }

    function discardInputChanges() {
        let savedSelect = api.getSavedInputs();

        console.log(`discardInputChanges`, savedSelect);

        setInputTopSelected(savedSelect?.cameraTop);
        setInputBillBoardSelected(savedSelect?.cameraBillBoard);

        onVideoInputChange('top', savedSelect?.cameraTop?.value);
        onVideoInputChange('billboard', savedSelect?.cameraBillBoard?.value);

        setState({
            ...state
        });
    }

    /**
     * 
     * @returns 
     */
    function isInputSaved() {
        return true;
    }

    async function updateVideoInputOptions() {
        if (JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('output')) {
            JitsiMeetJS.mediaDevices.enumerateDevices(devices => {
                const videoInputDevices = devices.filter(d => d.kind === 'videoinput');
                const audioOutputDevices = devices.filter(d => d.kind === 'audiooutput');
                if (videoInputDevices.length > 1) {
                    // VIDEO FILTER
                    let videoInputs = [];

                    for (let i = 0; i < videoInputDevices.length; i++) {
                        const d = videoInputDevices[i];
                        videoInputs.push({
                            value: d.deviceId,
                            label: d.label
                        });
                    }
                    setInputVideoOptions(videoInputs);
                }
                if (audioOutputDevices.length > 1) {
                    // AUDIO FILTER
                    // setInputAudioOptions(videoInputs);
                }
            });
        }
    }

    function onVideoInputChange(view, deviceId) {
        console.log(`onVideoInputChange`, view, deviceId);
        let videoElement = null;
        let _inputTracks = inputTracks;

        switch (view) {
            case 'top':
                videoElement = refCameraTopViewVideo.current;
                break;
            case 'billboard':
                videoElement = refCameraBillboardVideo.current;
                break;
            default:
                break;
        }
        console.log(`onVideoInputChange:attach`, view, deviceId, videoElement);

        if (!!videoElement) {

            JitsiMeetJS.createLocalTracks({
                devices: ['video'],
                cameraDeviceId: deviceId
            }).then((tracks) => {
                // console.log(`onVideoInputChange`, tracks);
                if (!!_inputTracks[view]) {
                    _inputTracks[view].dispose();
                }
                for (let i = 0; i < tracks.length; i++) {
                    // attach to HTML frontend
                    if (tracks[i].getType() === 'video') {
                        tracks[i].attach(videoElement);
                        _inputTracks[view] = tracks[i];
                    }
                }
            }).catch((error) => {
                console.error(`createLocalTracks:error`, error);
            });
        }

        setInputTracks(_inputTracks);
    }

    function componentMount() {
        // Anything in here is fired on component mount.
        console.log(`SceneSetting mounted!`)
        const loading = async () => {

            setLoading(true);
            await updateVideoInputOptions();
            await loadTables();
            await loadInputs();
            setLoading(false);

            // call method to indicate that loading is done
            loadingContext.done();
        };

        loading();
    }

    function componentUnmount() {
        if (!!inputTracks['top']) {
            inputTracks['top'].dispose();
        }
        if (!!inputTracks['billboard']) {
            inputTracks['billboard'].dispose();
        }
    }

    useEffect(() => {
        componentMount();

        return () => {
            // Anything in here is fired on component unmount.
            console.log(`SceneSetting unounted!`);
            componentUnmount();
        }
    }, []);

    return (
        <>
            <div className="container-fluid">
                {isLoading
                    ?
                    <p className="placeholder-glow">
                        <span className="placeholder col-8"></span>
                        <span className="placeholder col-8"></span>
                        <span className="placeholder col-12"></span>
                        <span className="placeholder col-12"></span>
                        <span className="placeholder col-12"></span>
                    </p>
                    :
                    <div className="col-lg-8 mx-auto p-3 py-md-1">
                        <header className="d-flex align-items-center mb-5 border-bottom">
                            <i className="bi bi-gear-fill" style={{
                                'fontSize': '2em'
                            }} ></i>&nbsp;&nbsp;
                            <ul className="nav nav-tabs" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Room</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Inputs</button>
                                </li>
                            </ul>
                        </header>

                        <main>
                            <div className="tab-content" id="pills-tabContent">

                                {/* Room settings panel */}
                                <div className="tab-pane fade show active align-items-center justify-content-center" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                    <div className="col-md-7 col-lg-8">
                                        <h4 className="mb-3">Rooms</h4>
                                        <div className="row col-12">
                                            <div className="col-11">
                                                <Select
                                                    options={tableOptions}
                                                    value={tableSelected}
                                                    onChange={(selected) => {
                                                        setTableSelected(selected);
                                                    }} />
                                            </div>
                                            <div className="col-1">
                                                <button type="button" className="btn btn-primary" onClick={() => loadTables()}>
                                                    <i className="bi bi-arrow-clockwise"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Room Information */}
                                    <div className='row'>
                                        <div className="col-md-7 col-lg-8">
                                            <h4 className="mb-3">Current Room</h4>

                                            <div className="row g-3">

                                                <div className="col-12">
                                                    <label className="form-label">Name</label>
                                                    <input type="text" className="form-control" disabled value={tableSelected?.item?.name} />
                                                </div>

                                                <div className="col-12">
                                                    <label className="form-label">Room ID - <i>Streaming</i></label>
                                                    <div className="input-group has-validation">
                                                        <span className="input-group-text">@</span>
                                                        <input type="text" className="form-control" disabled value={tableSelected?.item.video_room_id} />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <label className="form-label">Status</label>
                                                    <input type="text" className="form-control" disabled value={tableSelected?.item?.status} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="my-4" />

                                    <div className='row m-3'>
                                        <div className='col-6'>
                                            <button type="button" className="w-100 btn btn-primary btn-lg" disabled={!!isTableChanges()} onClick={() => saveRoom()}>
                                                <i className="bi bi-hammer"></i> Save
                                            </button>
                                        </div>
                                        <div className='col-6'>
                                            <button type="button" className="w-100 btn btn-danger btn-lg" disabled={!!isTableChanges()} onClick={() => discardRoomChanges()}>
                                                <i className="bi bi-x-lg"></i> Discard
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Input settings panel */}
                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">

                                    {/* Camera Selections */}
                                    <div className='row'>

                                        {/* TOP CAMERA */}
                                        <div className="col-6">
                                            <h4 className="mb-3">Top Camera</h4>
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <Select
                                                        options={inputVideoOptions}
                                                        value={inputTopSelected}
                                                        onChange={(selected) => {
                                                            setInputTopSelected(selected);
                                                            onVideoInputChange('top', selected.value);
                                                        }} />
                                                </div>

                                                <div className="col-12">
                                                    <video width="100%" autoPlay="1" ref={refCameraTopViewVideo} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* BILLBOARD CAMERA */}
                                        <div className="col-6">
                                            <h4 className="mb-3">Billboard Camera</h4>
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <Select
                                                        options={inputVideoOptions}
                                                        value={inputBillBoardSelected}
                                                        onChange={(selected) => {
                                                            setInputBillBoardSelected(selected);
                                                            onVideoInputChange('billboard', selected.value);
                                                        }} />
                                                </div>

                                                <div className="col-12">
                                                    <video width="100%" autoPlay="1" ref={refCameraBillboardVideo} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="my-4" />

                                    <div className='row'>
                                        <div className='col-6'>
                                            <button type="button" className="w-100 btn btn-primary btn-lg" disabled={!isInputSaved()} onClick={() => saveInputs()}>
                                                <i className="bi bi-hammer"></i> Save
                                            </button>
                                        </div>
                                        <div className='col-6'>
                                            <button type="button" className="w-100 btn btn-success btn-lg" onClick={() => discardInputChanges()}>
                                                <i className="bi bi-arrow-clockwise"></i> Reload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                }
            </div >
        </>
    );
}

export default SceneSettings;